import _defineProperty from "@babel/runtime/helpers/defineProperty";
/*
 *                       NOTICE
 *            COPYRIGHT 2018 Ab Initio
 *           UNPUBLISHED -- ALL RIGHTS RESERVED
 *
 *     This program is confidential and a trade secret of Ab Initio.
 *     The receipt or possession of this program does not convey any
 *     rights to reproduce or disclose its contents, or to manufacture,
 *     use or sell anything that it may describe, in whole or in part,
 *     without the specific written consent of Ab Initio.
 */

import { MethodType } from "abweb/service/rpc/MethodType";
import { URLUtils } from "abweb/utils/URLUtils";
import { IdleMonitor } from "abweb/utils/IdleMonitor";

// TODO @TestFixup(dev=elovy, productionIssue=true) Disabled ActivationE2E.testIdleTimeout for Edge as part of CAT-1083
export class ActivationManager {
  constructor(rpcService, configuration) {
    _defineProperty(this, "rpcService", void 0);
    _defineProperty(this, "_isActive", true);
    _defineProperty(this, "inErrorHandler", false);
    _defineProperty(this, "activationUpdateStamp", void 0);
    _defineProperty(this, "activationListener", void 0);
    _defineProperty(this, "activator", () => {
      if (!this._isActive) {
        return Promise.resolve(false);
      }
      return this.rpcService.invokeRetJSON(this.getActivationURL(true), null, MethodType.POST, false).then(newState => {
        if (!this._isActive) {
          return false;
        }
        if (newState.updateStamp !== this.activationUpdateStamp) {
          this.activationUpdateStamp = newState.updateStamp;
          return this.activator();
        }
        return true;
      });
    });
    this.rpcService = rpcService;
    this.activationUpdateStamp = configuration.activationState.updateStamp;
    window.onfocus = () => {
      this._isActive = true;
      setTimeout(() => this.activateSession(), configuration.activationDelay * 1000);
    };
    window.onblur = () => {
      this._isActive = false;
      setTimeout(() => this.deactivateSession(), 0);
    };
    setTimeout(() => this.activateSession(), configuration.activationDelay * 1000);
    if (configuration.activationTimeout > 0) {
      IdleMonitor.addListener(configuration.activationTimeout, () => {
        this._isActive = false;
        setTimeout(() => this.deactivateSession(), 0);
      }, () => {
        this._isActive = true;
        setTimeout(() => this.activateSession(), 0);
      });
    }
  }
  registerListener(listener) {
    this.activationListener = listener;
  }
  activateSession() {
    if (!this._isActive || this.inErrorHandler) {
      return;
    }
    this.activator().catch(e => {
      if (this.activationListener) {
        this.inErrorHandler = true;
        this.activationListener(e).then(() => {
          this.inErrorHandler = false;
        });
      }
    });
  }
  deactivateSession() {
    if (this._isActive || this.inErrorHandler) {
      return Promise.resolve();
    }
    return this.rpcService.invokeRetJSON(this.getActivationURL(false), null, MethodType.POST, false).then(newState => {
      if (!this._isActive && newState.updateStamp !== this.activationUpdateStamp) {
        this.activationUpdateStamp = newState.updateStamp;
        setTimeout(() => this.deactivateSession(), 0);
      }
    });
  }
  getActivationURL(activate) {
    let activationParams = {};
    activationParams[ActivationManager.ACTIVATION_ACTIVE] = activate;
    activationParams[ActivationManager.ACTIVATION_UPDATE_STAMP] = this.activationUpdateStamp;
    return URLUtils.appendQueryParamsToUrl("/api/abweb/session/active", activationParams);
  }

  /*
   * Utilities for testing
   */

  get isActive() {
    return this._isActive;
  }
  get updateStamp() {
    return this.activationUpdateStamp;
  }
}
_defineProperty(ActivationManager, "ACTIVATION_ACTIVE", "active");
_defineProperty(ActivationManager, "ACTIVATION_UPDATE_STAMP", "activationUpdateStamp");
//# sourceMappingURL=ActivationManager.js.map
